import type { RateProvider } from "../core/index.ts";

/**
 * Live exchange rates via ExchangeRate-API (free tier, 166 currencies).
 * Cached per session. Same-currency shortcuts to 1. Throws on unavailable
 * pair so import aborts untouched (contract §0.6).
 */
export class LiveRates implements RateProvider {
  private cache = new Map<string, number>();

  async rate(from: string, to: string): Promise<number> {
    if (from === to) return 1;
    const key = `${from}>${to}`;
    const cached = this.cache.get(key);
    if (cached != null) return cached;
    const res = await fetch(`https://open.er-api.com/v6/latest/${encodeURIComponent(from)}`);
    if (!res.ok) throw new Error(`Rate lookup failed for ${from}->${to}`);
    const json = (await res.json()) as { base_code?: string; rates?: Record<string, number> };
    const r = json.rates?.[to];
    if (r == null) throw new Error(`No rate for ${from}->${to}`);
    this.cache.set(key, r);
    return r;
  }
}
